import { render } from "./NavItem.vue?vue&type=template&id=0502ec46&scoped=true"
import script from "./NavItem.vue?vue&type=script&lang=js"
export * from "./NavItem.vue?vue&type=script&lang=js"

import "./NavItem.vue?vue&type=style&index=0&id=0502ec46&lang=scss&scoped=true"
import "./NavItem.vue?vue&type=style&index=1&id=0502ec46&lang=scss"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0502ec46"]])

export default __exports__